module.exports = __webpack_public_path__ + "media/images/social_icons/pinterest-639b60736476b77e2cff4f922ed79687.png";